/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Image from '../../Image';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useHistory, useLocation } from 'react-router-dom';

import DefaultImage from '../images/sports/futbol/default.png';

import { useEffect, useState } from 'react';
import { resetGame } from '../../../modules/sport/actions/reducerGame';
import { useDispatch } from 'react-redux';
import { resetClubReset } from '../../../modules/sport/actions/reducerListClub';
import { dateList } from '../../data/dateList';

function getWindowDimensions() {
    if (typeof window !== 'undefined') {
        const { innerWidth: width } = window;
        return {
            width,
        };
    } else {
        return {
            width: null,
        };
    }
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export default function Card(props): JSX.Element {
    const dispatch = useDispatch();
    const { attribute, details, propCard, select, setSelect, filter, type, filterQuery, origin = '' } = props;
    //console.log(propCard.minWidthImage, { details });
    const { width } = useWindowDimensions();
    const [widthImage /*, setWidthImage*/] = useState(propCard?.widthImage);
    const [heightImage /*, setHeightImage*/] = useState(propCard?.heightImage | 120);
    const router = useHistory();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const attributeUrl = pathname.length > 1 ? pathname[2] : '';

    const handleDragStart = (e) => {
        e.preventDefault();
    };

    const handleGo = () => {
        let path = '/';
        let pathQuery = '';
        //console.log('attributeUrl:', attributeUrl, origin);
        if (attributeUrl === 'arrienda' || attributeUrl === 'desafiar') {
            dispatch(resetClubReset());
            if (origin === 'defy-team' && attributeUrl === 'desafiar') {
                path = `/${sport}/${attributeUrl}/equipo/filter`;
            } else {
                path = `/${sport}/${attributeUrl}/reservar/filter`;
            }

            //console.log('details :', { details, origin });
            if (path) {
                if (filter && filter.id) {
                    if (origin === 'defy-team' && attributeUrl === 'desafiar') {
                        const search = `?challengeId=${details.id ? details.id : ''}&region=${details.regionId}&day=${
                            filter.id ? filter.id : ''
                        }&challengedTeamName=${filterQuery.challengedTeamName}`;
                        router.push({
                            pathname: path,
                            search: search,
                        });
                    } else {
                        const search = `?day=${filter.id ? filter.id : ''}&club=${
                            details.id ? details.id : ''
                        }&region=${attributeUrl === 'desafiar' ? details.regionId : details.region}&challengedTeamId=${
                            filterQuery.challengedTeamId
                        }&challengedTeamName=${filterQuery.challengedTeamName}`;
                        router.push({
                            pathname: path,
                            search: search,
                        });
                    }
                } else {
                    if (origin === 'defy-team' && attributeUrl === 'desafiar') {
                        const search = `?challengeId=${details.id ? details.id : ''}&region=${
                            details.regionId
                        }&challengedTeamName=${filterQuery.challengedTeamName}`;
                        router.push({
                            pathname: path,
                            search: search,
                        });
                    } else {
                        const search = `?club=${details.id ? details.id : ''}`;
                        router.push({
                            pathname: path,
                            search: search,
                        });
                    }
                }
            }
        } else if (attributeUrl === 'integrar') {
            dispatch(resetGame);
            if (filterQuery && (filterQuery.commune || filterQuery.day || filterQuery.region)) {
                pathQuery = `&region=${filterQuery.region}&commune=${filterQuery.commune}&day=${filterQuery.day}`;
            }
            path = `/${sport}/${attributeUrl}/unirse/filter`;
            if (path) {
                const search = `?gameId=${details.id ? details.id : ''}${pathQuery}`;
                router.push({
                    pathname: path,
                    search: search,
                });
            }
        } else {
            if (attribute.type === 'rent') {
                path = `/${sport}/arrienda/reservar/filter`;
                //console.log('details', details);
                const startDate = details.startDate;
                //console.log({ startDate });
                const listDate = dateList();
                const day = listDate.find((d) => d.dateFormat === startDate);
                //console.log({ day, startDate });
                if (path && day) {
                    const search = `?club=${details.id ? details.id : ''}&day=${day ? day.id : ''}&region=${
                        details.region
                    }`;
                    router.push({
                        pathname: path,
                        search: search,
                    });
                }
            }
            if (attribute.type === 'integrate') {
                if (filterQuery && (filterQuery.commune || filterQuery.day || filterQuery.region)) {
                    pathQuery = `&region=${filterQuery.region}&commune=${filterQuery.commune}&day=${filterQuery.day}&challengedTeamId=${filterQuery.challengedTeamId}&challengedTeamName=${filterQuery.challengedTeamName}`;
                }
                path = `/${sport}/integrar/unirse/filter`;
                //console.log({ path });
                if (path) {
                    const search = `?gameId=${details.id ? details.id : ''}${pathQuery}`;
                    router.push({
                        pathname: path,
                        search: search,
                    });
                }
            }
            if (attribute.type === 'defy') {
                path = `/${sport}/desafiar/equipo/filter`;
                if (path) {
                    const search = `?challengeId=${details.id}`;
                    router.push({
                        pathname: path,
                        search: search,
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (width && width < 640) {
            // setWidthImage(380);
            //setHeightImage(150);
        }
    }, []);

    return (
        <figure
            className={`relative ${propCard?.wMovil} ${propCard?.w} ${propCard?.h} ${propCard?.hAutoMovil} ${propCard?.hAuto} ${propCard?.others}`}
            key={`figure-${details.id}`}
            onDragStart={handleDragStart}
            id="Card"
        >
            <div
                className={`${propCard?.card} ${
                    select && select.id && select.id === details.id
                        ? attribute.color.bgButton
                        : propCard?.activeHoverCard && 'hover:bg-sm-integrate hover:text-white'
                }`}
                onClick={() => {
                    propCard?.activeHoverCard && setSelect(details);
                }}
            >
                {details && details.image && (
                    <div className={`relative`}>
                        <Image
                            imgClassName={`rounded-t-lg p-0 m-0`}
                            className={`${propCard?.hAutoMovil} ${propCard?.hAuto}`}
                            src={details.image ? details.image : DefaultImage}
                            width={widthImage}
                            height={heightImage}
                            maxWidth={widthImage}
                            maxHeight={heightImage}
                            minWidth={null || propCard?.minWidthImage}
                            key={`img-${details.id}`}
                            alt="presentation"
                        />
                        {attribute.type === 'integrate' && details.maxCapacity && (
                            <>
                                <div
                                    className={`absolute top-0 right-0 p-0 m-0  w-full h-full bg-white bg-opacity-70 rounded-t-lg reserved-game`}
                                ></div>
                                <div className={'absolute top-2 right-8  italic text-xl font-bold'}>
                                    {details.reservedPlayer}
                                </div>
                                <div className={'absolute top-3 right-6  italic text-xl font-bold'}>
                                    <div className={'text-yellow-500'}>/</div>
                                </div>
                                <div className={'absolute top-5 right-2 italic text-xl font-bold'}>
                                    {details.maxCapacity}
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div
                    className={`flex flex-col ${propCard?.h} ${propCard?.hMovil} ${propCard?.hAuto} items-center justify-center content-center`}
                >
                    <div className={`${propCard?.content} ${attribute.type === 'defy' ? 'w-full' : ''}  `}>
                        {details.title && (
                            <>
                                <div className={`relative flex-col ${details.subtitle ? 'h-10' : 'h-6'}`}>
                                    <div className="flex justify-center content-center">
                                        {' '}
                                        <p className=" flex w-full flex-col text-sm font-bold leading-4">
                                            {attribute.type === 'defy'
                                                ? details.title.substring(0, 46)
                                                : details.title.substring(0, 59)}
                                        </p>
                                        {details.subtitle && (
                                            <>
                                                {' '}
                                                <p
                                                    className={`hidden md:absolute md:flex w-full flex-col text-sm font-bold leading-4 ${
                                                        attribute.type === 'defy' ? 'pt-8' : 'pt-6'
                                                    }`}
                                                >
                                                    {details.subtitle.substring(0, 34)}
                                                </p>
                                                <p
                                                    className={`md:hidden absolute flex w-full flex-col text-xs  font-bold leading-4 ${
                                                        attribute.type === 'defy' ? 'pt-8' : 'pt-6'
                                                    }`}
                                                >
                                                    {details.subtitle.substring(0, 23)}
                                                </p>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                        <div
                            className={`flex text-center items-center justify-center content-center  w-full pt-2 md:pt-0`}
                        >
                            <figcaption
                                className={`flex-col w-full text-center text-sm items-center  justify-center content-center ${
                                    select && select.id && select.id === details.id && 'text-white'
                                }`}
                            >
                                {details.day && (
                                    <div className={`${propCard?.cardText} md:py-2 py-0 `}>{details.day}</div>
                                )}
                                {details.hrs && <div className={`text-xs h-7 leading-4`}>{details.hrs}</div>}
                                {details.address ? (
                                    <div className={`hidden md:block  h-7 leading-4`}>{details.address}</div>
                                ) : (
                                    type === 'list' &&
                                    attribute.type !== 'defy' && <div className="hidden md:block  h-7">{''}</div>
                                )}
                                {details.commune && <div className={``}>{details.commune}</div>}
                                {details.club && <div className={`h-7 leading-4`}>{details.club}</div>}

                                {details.date && <div>{details.date}</div>}
                            </figcaption>
                        </div>
                    </div>
                    {propCard?.activeButton && (
                        <div className={`pt-2 pb-2 text-center`}>
                            <button
                                className={`${attribute.color.bgButton} contact-button rounded-2xl text-white text-xs uppercase py-2 px-4 md:px-12 font-extrabold`}
                                type="button"
                                onClick={() => {
                                    handleGo();
                                }}
                            >
                                {attribute.type === 'defy'
                                    ? origin === 'defy-club'
                                        ? 'SELECCIONAR'
                                        : details &&
                                          details.challengedName &&
                                          (details.challengedName !== ' ' || details.challengedName !== '')
                                        ? 'Partido Completo'
                                        : type === 'list'
                                        ? attribute.bt.card
                                        : type === 'list-defy'
                                        ? 'CREAR DESAFIO'
                                        : attribute.bt.name
                                    : attribute.bt.name}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </figure>
    );
}
